import { render, staticRenderFns } from "./CooperationAgreement.vue?vue&type=template&id=411bde95&"
import script from "./CooperationAgreement.vue?vue&type=script&lang=js&"
export * from "./CooperationAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports